import { render, staticRenderFns } from "./EditDayOffModal.vue?vue&type=template&id=ca2fd94a"
import script from "./EditDayOffModal.vue?vue&type=script&lang=js"
export * from "./EditDayOffModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports